/**
 * KDS Checkbox — Kintsugi Design System node 1053:13383.
 *
 * Figma defines two sizes. Chakra `size` values match org/admin/partner call sites
 * so follow-on migration is an import swap (no prop renames).
 *
 * | KDS   | `size` | Control   | Hit target | Border   | Icon |
 * | ----- | ------ | --------- | ---------- | -------- | ---- |
 * | Small | `sm`   | 16×16 px  | 24×24 px   | 1.25px   | 12px |
 * | Large | `lg`   | 24×24 px  | 24×24 px   | 1.5px    | 16px |
 *
 * Corner radius: Figma `xs-radius` = 4px (`radii.sm` in KDS tokens).
 * Default border: `brand.500` (Primary/500).
 */
export const checkboxControlSize = {
  sm: '16px',
  lg: '24px',
} as const;

/** Small size centers the 16px control in a 24px hit target (Figma `checkbox` wrapper). */
export const checkboxHitTargetSize = {
  sm: '24px',
} as const;

export const checkboxBorderWidth = {
  sm: '1.25px',
  lg: '1.5px',
} as const;

/** Check / dash icon — 12px in 16px box (sm), 16px in 24px box (lg). */
export const checkboxIndicatorSize = {
  sm: '12px',
  lg: '16px',
} as const;

/** Figma `xs-radius` — 4px, mapped to `radii.sm`. */
export const checkboxBorderRadius = 'sm';

export const checkboxSizes = Object.keys(checkboxControlSize) as Array<keyof typeof checkboxControlSize>;

export type CheckboxSize = keyof typeof checkboxControlSize;
